export default "__VITE_ASSET__CcB3429$__"